import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { environment } from '../../../environments/environment';
import { Title, Meta } from '@angular/platform-browser';
import { Pave } from '../../models/pave.model';
import { OffreEmploi } from '../../models/offreEmploi.model';

@Component({
  selector: 'offres-emploi',
  templateUrl: './offres-emploi.component.html',
  styleUrls: ['./offres-emploi.component.scss']
})
export class OffresEmploiComponent {
  environment = environment;

  offresEmploi: OffreEmploi[];
  paves: Pave[];

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private metaTagService: Meta
  ) {
    this.titleService.setTitle('Centre de Formation du Languedoc');
    this.metaTagService.updateTag({
      name: 'description',
      content: 'BTS SP3S, BTS MCO, BTS SIO, offres d\'emploi'
    });
    this.offresEmploi = JSON.parse(this.route.snapshot.data.offresEmploi);
    this.paves = JSON.parse(this.route.snapshot.data.paves);
  }

}
